import React, { useState, useEffect } from 'react';
import AuthenticatedComponent from './AuthenticatedComponent'
import HeatingService from '../services/HeatingService.js';
import { HEATING_URL } from '../constants/HeatingConstants';
import { useSelector } from 'react-redux'

function Heating() {
  const { _totalFordelingstal, _totalHeathoses } = useSelector(state => state.heating);
  
  const [companies, setCompanies] = useState(false);
  const [movers, setMovers] = useState(false);
  const [month, setMonth] = useState('');
  const [heatusage, setHeatusage] = useState('');
  const [heattax, setHeattax] = useState('');
  const [afskrivning, setAfskrivning] = useState('');
  const [energycontrol, setEnergycontrol] = useState('');
  const [energibrand, setEnergibrand] = useState('');
  const [heatinghoses, setHeatinghoses] = useState(_totalHeathoses);
  const [fordelingstal, setFordelingstal] = useState(_totalHeathoses);

  const requestBoth = () => {
    HeatingService.get();
  };

  useEffect(() => {
    requestBoth();
  }, []);

  useEffect(() => {
    setHeatinghoses(_totalHeathoses);
    setFordelingstal(_totalFordelingstal);
  }, [_totalHeathoses, _totalFordelingstal]);

  const generateReport = () => {
    if (companies) {
      window.location = HEATING_URL + "/" + month + "/" + heatusage + "/" + heattax + "/" + afskrivning + "/" + energycontrol + "/" + energibrand + "/" + movers + "/erhverv/varmeregnskab";
    }
    else {
      window.location = HEATING_URL + "/" + month + "/" + heatusage + "/" + heattax + "/" + energycontrol + "/" + energibrand + "/" + movers + "/varmeregnskab";
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="standardBackground col-md-4 offset-md-4">
          {heatinghoses &&
            <div className="form-group">
              <label>Totale antal varmehaner</label><br />
              {heatinghoses}
            </div>}
          {fordelingstal &&
            <div className="form-group">
              <label>Totale fordelingstal</label><br />
              {fordelingstal}
            </div>}
          <div className="form-group">
            <label>Fjernvarme - forbrug (kr.)</label>
            <input type="text" value={heatusage} onChange={(event) => setHeatusage(event.target.value)} className=" form-control" />
          </div>
          <div className="form-group">
            <label>Fjernvarme - fast afgift (kr.)</label>
            <input type="text" value={heattax} onChange={(event) => setHeattax(event.target.value)} className=" form-control" />
          </div>
          <div className="form-group">
            <label>Energistyring (kr.)</label>
            <input type="text" value={energycontrol} onChange={(event) => setEnergycontrol(event.target.value)} className=" form-control" />
          </div>
          <div className="form-group">
            <label>Energimærke (kr.)</label>
            <input type="text" value={energibrand} onChange={(event) => setEnergibrand(event.target.value)} className=" form-control" />
          </div>
          <div className="form-group">
            <label>Måned for start af tilbagebetaling over boligafgift</label>
            <input type="text" value={month} onChange={(event) => setMonth(event.target.value)} className=" form-control" />
          </div>
          <div className="form-group">
            <label className="col-md-12 marginLeft1" >Skal der laves regnskab for fraflyttere?</label>
            <input className="col-md-12" type="checkbox" checked={movers} onChange={(event) => setMovers(event.target.checked)} />
          </div>
          <div className="form-group">
            <label className="col-md-12 marginLeft1" >Skal der laves regnskab for erhverv?</label>
            <input className="col-md-12" type="checkbox" checked={companies} onChange={(event) => setCompanies(event.target.checked)} />
          </div>
          {companies &&
            <div>
              <div className="form-group">
                <label>Afskrivning af varmeanlæg (kr.)</label>
                <input type="text" value={afskrivning} onChange={(event) => setAfskrivning(event.target.value)} className=" form-control" />
              </div>
            </div>
          }
          <div className="form-group slightMarginTopApartments">
            <button className="btn btn-primary" onClick={() => generateReport()}>Generer varmeregnskab</button>
          </div>
        </div>
      </div>
    </div>
  );
}


export default AuthenticatedComponent(Heating)